import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {healthRoutes} from './health-family-routes';
import {BrowserModule} from '@angular/platform-browser';
import {ErrorStateMatcher, MAT_LABEL_GLOBAL_OPTIONS, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import {RouterModule, Routes} from '@angular/router';

import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {NewHealthRequestComponent} from './new-health-request/new-health-request.component';
import {BasicInformationComponent} from './basic-information/basic-information.component';
import {NewSubRequestComponent} from './new-sub-request/new-sub-request.component';
import {OfferSelectComponent} from './offer-select/offer-select.component';
import {SubRequestDetailsComponent} from './sub-request-details/sub-request-details.component';
import {QuestionsComponent} from './questions/questions.component';
import {
  MatListModule,
  MatFormFieldModule,
  MatExpansionModule,
  MatInputModule,
  MatSelectModule,
  MAT_CHECKBOX_CLICK_ACTION,
  MatCardModule,
  MatCheckboxModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatIconModule
} from '@angular/material';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {NotFoundModule} from '../not-found/not-found.module';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {FileUploadDivModule} from '../../Elements/file-upload-div/file-upload-div.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import {FinanceInvoiceDivModule} from '../../Elements/finance-invoice-div/finance-invoice-div.module';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {FormModule} from '../../Elements/form/form.module';
import {HeightWeightComponent} from '../../Elements/height-weight/height-weight.component';

@NgModule({
  declarations: [
    MainMenuComponent,
    NewHealthRequestComponent,
    BasicInformationComponent,
    NewSubRequestComponent,
    OfferSelectComponent,
    SubRequestDetailsComponent,
    QuestionsComponent,
    HeightWeightComponent
  ],
    exports: [
        SubRequestDetailsComponent
    ],
  imports: [
    CommonModule,
    RouterModule.forChild(healthRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDatepickerModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    MainNavBarModule,
    NotFoundModule,
    DetailsDivModule,
    FileUploadDivModule,
    FormListGeneratorModule,
    FinanceInvoiceDivModule,
    CustomButtonModule,
    FormModule
  ],
  entryComponents: [HeightWeightComponent],
  providers: [
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher}
  ]
})
export class HealthFamilyApplicationModule {
}
